import { Component } from '@angular/core';
import { HeaderComponent } from "../../../../layout/header/header.component";
import { NavbarComponent } from "../../../../layout/navbar/navbar.component";
import { SidebarComponent } from "../../../../layout/sidebar/sidebar.component";
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { LangChangeEvent, TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { ServicesService } from '../../../../services/services.service';
import { ServiceDto, serviceRequest, ServiceResponse } from '../../../../models/servicedto';
import { AlertComponentComponent } from "../../../../components/alert/alert-component.component";
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { SharedService } from '../../../../services/shared.service';
import { Subscription } from 'rxjs';
import { MessageInputComponent } from "../../../../layout/message-input/message-input.component";

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [HeaderComponent, NavbarComponent, SidebarComponent, CommonModule, ReactiveFormsModule, TranslatePipe, PaginatorComponent, AlertComponentComponent, MessageInputComponent],
  templateUrl: './services.component.html',
  styleUrl: './services.component.css'
})
export class ServicesComponent {
  links: any[] = []; // Lista de links para el sidebar
  subLinks: any[] = []; // Lista de links para el sidebar

  serviceReponse: ServiceResponse = new ServiceResponse();
  serviceReponseTraductions: ServiceDto[] = [];
  serviceRequest: serviceRequest = new serviceRequest();
  serveiSelected: ServiceDto = new ServiceDto();
  selectedRowId: number | null = null;
  serviceForm!: FormGroup;
  isCreate: boolean = false;
  errorMessage: string = '';
  messageVisibility: messageVisibility = new messageVisibility()
  private langChangeSubscription!: Subscription;

  constructor(private routelinks: RoutelinksService, private translateService: TranslateService, private servicesService: ServicesService, private formBuilder: FormBuilder, public sharedService: SharedService

  ) { }

  ngOnInit(): void {
    this.links = this.routelinks.linksTaxes; // Inicializa la propiedad en ngOnInit
    this.subLinks = this.routelinks.subLinksTaxes; // Inicializa la propiedad en el constructor

    this.initFormReactiveService();
    this.getAllServices();
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.serviceRequest.pageRequest.page = page;
      this.getAllServices();
    });
    this.langChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.getAllServices();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  private initFormReactiveService(): void {
    this.serviceForm = this.formBuilder.group({
      idService: [0],
      codeService: ['', [Validators.required]],
      active: new FormControl(true),
      descriptionCas: ['', [Validators.required]],
      descriptionCat: ['', [Validators.required]],
      descriptionEng: ['', [Validators.required]],
    });
  }

  getAllServices() {
    this.servicesService.getAllServices().subscribe({
      next: response => {
        if (response != null) {
          this.serviceReponseTraductions = response.listServiceDto
          this.serviceReponse.listService = response.listServiceDto.map((rt: any) => {
            return {
              ...rt,
              serviceTraductionDto: rt.serviceTraductionDto.filter((t: any) => { return t.languageDto.code.includes(this.translateService.currentLang || 'es') }),
            };
          });
          response.pageDto !== undefined ? this.serviceReponse.pageDto = response.pageDto : null
        }
      }, error: error => {
        console.log('Se ha producido un error', error);
      }
    });
  }

  checkRow(service?: ServiceDto) {
    if (service) {
      if (this.selectedRowId === service.idService) {
        this.selectedRowId = null;
        return;
      }
      // Modo edición
      let serv = this.serviceReponseTraductions.filter(trad => { return trad.idService == service.idService })
      this.serveiSelected = serv[0]
      this.serviceForm.get('idService')?.disable()
      this.selectedRowId = Number(serv[0].idService);
      this.isCreate = false;
      serv[0].serviceTraductionDto.forEach(serv => {
        serv.languageDto?.code == 'es' ? this.serviceForm.get('descriptionCas')?.patchValue(serv.shortDescription) : null;
        serv.languageDto?.code == 'ca' ? this.serviceForm.get('descriptionCat')?.patchValue(serv.shortDescription) : null;
        serv.languageDto?.code == 'en' ? this.serviceForm.get('descriptionEng')?.patchValue(serv.shortDescription) : null;
      }
      )
      this.serviceForm.patchValue({
        idService: serv[0].idService,
        codeService: serv[0].codeService,
        active: serv[0].active,
      });
    } else {
      // Modo creación
      this.selectedRowId = null;
      this.isCreate = true;
      this.serviceForm.enable();
      this.serviceForm.reset();
      this.serviceForm.patchValue({
        active: true
      });
    }
    window.scrollTo(0, 600);
  }

  deleteServiceById() {
    this.servicesService.deleteService(this.selectedRowId).subscribe({
      next: () => {
        this.resetValues()
        this.messageVisibility.isSuccessFirst = true;
        this.errorMessage = 'Servei esborrat'
      }, error: error => {
        this.messageVisibility.isErrorFirts = true;
        this.messageVisibility.isSuccessFirst = false;
        this.errorMessage = error.errorMessage
        console.log(error);
      }
    })
  }

  createOrUpdateService(): void {
    //modo creacion
    if (this.serviceForm.valid) {


      this.buildServiceDto()
      if (!this.selectedRowId) {
        this.servicesService.createService(this.serviceRequest.serviceDto).subscribe({
          next: (response) => {
            this.messageVisibility.isErrorFirts = false;
            this.messageVisibility.isSuccessFirst = true;
            this.errorMessage = "S'ha creat correctament"
            this.getAllServices()
          }, error: (error) => {
            console.log(error)
            this.messageVisibility.isErrorFirts = true;
            this.messageVisibility.isSuccessFirst = false;
            this.errorMessage = error.error.message
          }
        })
      }
      //modo edicion
      else {
        this.servicesService.updateService(this.serviceRequest.serviceDto).subscribe({
          next: (response) => {
            this.messageVisibility.isErrorFirts = false;
            this.messageVisibility.isSuccessFirst = true;
            this.errorMessage = "S'ha editat correctament"
            this.getAllServices()
          }, error: (error) => {
            console.log(error)
            this.messageVisibility.isErrorFirts = true;
            this.messageVisibility.isSuccessFirst = false;
            this.errorMessage = error.error.message
          }
        })
      }
    } else {
      this.serviceForm.markAllAsTouched()
      this.messageVisibility.isErrorFirts = true;
      this.errorMessage = 'obligatorios'

    }
  }

  private buildServiceDto(): void {
    if (this.selectedRowId) {
      this.serviceRequest.serviceDto.idService = this.selectedRowId || undefined; // Asigna el ID de la tasa académica seleccionada
      this.serviceRequest.serviceDto.serviceTraductionDto = [
        { languageDto: { idLanguage: 1 }, shortDescription: undefined, idServiceTraduction: this.serveiSelected.serviceTraductionDto?.filter(serv => { return serv.languageDto?.idLanguage == 1 })[0].idServiceTraduction },
        { languageDto: { idLanguage: 2 }, shortDescription: undefined, idServiceTraduction: this.serveiSelected.serviceTraductionDto?.filter(serv => { return serv.languageDto?.idLanguage == 2 })[0].idServiceTraduction },
        { languageDto: { idLanguage: 3 }, shortDescription: undefined, idServiceTraduction: this.serveiSelected.serviceTraductionDto?.filter(serv => { return serv.languageDto?.idLanguage == 3 })[0].idServiceTraduction }
      ];
    } else {
      this.serviceRequest.serviceDto.idService = this.serviceForm.get('idService')?.value
      this.serviceRequest.serviceDto = new ServiceDto(); // Inicializa de 0 el objeto
      if (this.serviceRequest.serviceDto.serviceTraductionDto) {
        this.serviceRequest.serviceDto.serviceTraductionDto = [
          { languageDto: { idLanguage: 1 }, idServiceTraduction: undefined, shortDescription: undefined },
          { languageDto: { idLanguage: 2 }, idServiceTraduction: undefined, shortDescription: undefined },
          { languageDto: { idLanguage: 3 }, idServiceTraduction: undefined, shortDescription: undefined }
        ]; // Inicializa ownAcademicFeeTraductionDto si es undefined o vacío; // Inicializa el array de traducciones si es nulo
      }
    }
    this.serviceRequest.serviceDto.codeService = this.serviceForm.get('codeService')?.value;
    this.serviceForm.get('active')?.value ? this.serviceRequest.serviceDto.active = 'S' : this.serviceRequest.serviceDto.active = 'N';// Asigna el estado activo
    this.serviceRequest.serviceDto.serviceTraductionDto?.forEach((translation) => {
      if (translation.languageDto?.code === "es" || translation.languageDto?.idLanguage === 1) {
        translation.shortDescription = this.serviceForm.get('descriptionCas')?.value ?? undefined;
      } else if (translation.languageDto?.code === "ca" || translation.languageDto?.idLanguage === 2) {
        translation.shortDescription = this.serviceForm.get('descriptionCat')?.value ?? undefined;
      } else if (translation.languageDto?.code === "en" || translation.languageDto?.idLanguage === 3) {
        translation.shortDescription = this.serviceForm.get('descriptionEng')?.value ?? undefined;
      }
    });
  }

  private resetValues(): void {
    this.getAllServices();
    this.serviceForm.reset();
    this.selectedRowId = null;
  }
}
